var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.minimal.loaded
    ? _c(
        "footer",
        {
          staticClass: "ns-footer",
          class: {
            rtl: _vm.dir === "rtl",
            "ns-minimal-footer": _vm.minimal.active
          }
        },
        [
          _c(
            "section",
            {
              staticClass: "footer-top",
              class: { "show-my-site-background-color": _vm.useMysiteFooter },
              attrs: { hidden: _vm.noExpandedFooter }
            },
            [
              _vm._t("logo-container", [
                _vm.useMysiteFooter
                  ? _c("NsFooterStorefront", {
                      attrs: { storefront: _vm.footer.storefront }
                    })
                  : _c("div", { staticClass: "logo-container" }, [
                      _c(
                        "div",
                        { staticClass: "ns-container" },
                        [
                          !_vm.hideLogo
                            ? _vm._t("logo", [
                                _c("NsLogo", {
                                  attrs: {
                                    "is-white": !_vm.minimal.active,
                                    "is-word-mark": true,
                                    "alt-text": "Nu Skin Logo on the Footer",
                                    "link-url": ""
                                  }
                                })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.hideJoinButton && _vm.showJoinButton
                            ? _c(
                                "div",
                                { staticClass: "logo-container-button" },
                                [
                                  _vm._t("join-button", [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "inverse-ghost join-button",
                                        attrs: {
                                          href: _vm.getFullyQualifiedUrl(
                                            _vm.footer.joinNuskinUrl
                                          )
                                        },
                                        on: { click: _vm.joinButtonClick }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.footer.joinNuskin) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                2
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ])
              ]),
              _vm._v(" "),
              !_vm.useMysiteFooter
                ? _vm._t("navigation-container", [
                    _c("div", { staticClass: "navigation-container" }, [
                      _c(
                        "div",
                        { staticClass: "ns-container" },
                        [
                          _vm._t("footer-nav", [
                            _c("NsFooterNav", {
                              attrs: {
                                navigation: _vm.footer.navigation,
                                expandbreakpoint: _vm.expandbreakpoint,
                                minimal: _vm.minimal.active
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "social-icons" },
                            [
                              _vm._t("social-icons", [
                                _vm.showSocialIcons
                                  ? _c("NsSocialIcons", {
                                      attrs: {
                                        "social-media-header-text":
                                          _vm.footer.socialMediaHeaderText,
                                        "social-media-list":
                                          _vm.footer.socialMediaList,
                                        stacked: _vm.$mq !== "tablet",
                                        minimal: _vm.minimal.active
                                      }
                                    })
                                  : _vm._e()
                              ])
                            ],
                            2
                          )
                        ],
                        2
                      )
                    ])
                  ])
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _vm.footer.detailsLinks.length > 0 ||
          _vm.footer.enablegdprcookiepreferences
            ? _c("section", { staticClass: "footer-bottom" }, [
                _c(
                  "div",
                  { staticClass: "max-crop" },
                  [
                    _vm._t("bottom-links", [
                      _vm._l(_vm.footer.detailsLinks, function(detailLink) {
                        return _c(
                          "div",
                          { key: detailLink.name, staticClass: "bottom-link" },
                          [
                            _c("a", {
                              staticClass: "base",
                              attrs: {
                                href: _vm.getFullyQualifiedUrl(detailLink.href),
                                target: "_self"
                              },
                              domProps: { innerHTML: _vm._s(detailLink.name) }
                            })
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm._t("gdpr-section", [
                        _vm.footer.enablegdprcookiepreferences
                          ? _c("div", { staticClass: "bottom-link" }, [
                              _c("span", { attrs: { id: "teconsent" } })
                            ])
                          : _vm._e()
                      ])
                    ])
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.footer.seals.length > 0 && _vm.minimal.active
                  ? _c(
                      "div",
                      {
                        staticClass: "seals-container seals-container-minimal"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "max-crop" },
                          _vm._l(_vm.footer.seals, function(seal) {
                            return _c(
                              "div",
                              { key: seal.title, staticClass: "seal" },
                              [
                                _vm.hasValidLink(seal)
                                  ? _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: seal.sealHref,
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.getFullyQualifiedUrl(
                                              seal.sealImageUrl
                                            ),
                                            alt: seal.title
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.useMysiteFooter
            ? _vm._t("seal-icons", [
                _vm.footer.seals.length > 0
                  ? _c(
                      "div",
                      { staticClass: "seals-container seals-container-full" },
                      [
                        _c(
                          "div",
                          { staticClass: "max-crop" },
                          _vm._l(_vm.footer.seals, function(seal) {
                            return _c(
                              "div",
                              { key: seal.title, staticClass: "seal" },
                              [
                                _vm.hasValidLink(seal)
                                  ? _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: seal.sealHref,
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.getFullyQualifiedUrl(
                                              seal.sealImageUrl
                                            ),
                                            alt: seal.title
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }